export default "__VITE_ASSET__8c9feb57__"